/**
 * A clock that re-renders its component, at whatever cadence the caller needs right now.
 *
 * Every deadline on this screen was computed from `Date.now()` at render time, which is correct
 * exactly once — nothing re-rendered as the deadline approached, so a page left open through the
 * lock kept offering a Submit button that the rules had already closed. The interval is a prop
 * rather than a constant because the cadence changes: once a minute for thirteen days, once a
 * second for the last one, and never once it has passed.
 */

import { useEffect, useState } from 'react';

export function useNow(everyMs: number | null): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (everyMs === null) return undefined;
    // Fire once immediately: the interval that just changed may have been waiting a minute.
    setNow(Date.now());
    const id = window.setInterval(() => setNow(Date.now()), Math.max(250, everyMs));
    return () => window.clearInterval(id);
  }, [everyMs]);

  return now;
}
